import { useEffect } from "react";
import React from "react"
import { Outlet } from "react-router-dom";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { reloadWindowToPath } from "../Helpers/Utils";
import Layout from "../Partials/Layout";
import Unauthorized from "../Components/Unauthorized";

const PrivateRouters = ({ children }) => {
  const { isAuthenticated, unauthorized } = useAuth();
  useEffect(() => {
    if (!isAuthenticated && !unauthorized) {
      reloadWindowToPath("/login");
    }
  }, [isAuthenticated, unauthorized]);

  if (unauthorized) {
    return <Unauthorized />;
  }

  return (
    <React.Fragment>
      {isAuthenticated && (
        <Layout>
          {children}
          <Outlet />
        </Layout>
      )}
    </React.Fragment>
  );
}

export default PrivateRouters
